import React from 'react';
import './ContextualMedia.css';

interface ContextualMediaProps {
  children: React.ReactNode;
  media: React.ReactNode;
  /** Desktop only: which side the bound capture sits on. DOM stays copy → media. */
  mediaSide?: 'left' | 'right';
  /** 260px media column for very short instruction copy (avoids a tall lone device). */
  compactMedia?: boolean;
  className?: string;
}

/** Copy beside a bound device capture; stacks copy-then-media when narrow. */
const ContextualMedia: React.FC<ContextualMediaProps> = ({
  children,
  media,
  mediaSide = 'right',
  compactMedia = false,
  className = '',
}) => (
  <div className={`contextual-media ${className}`.trim()} data-side={mediaSide} data-mw={compactMedia ? '260' : '280'}>
    <div className="cm-inner">
      <div className="cm-copy">{children}</div>
      <div className="cm-media">{media}</div>
    </div>
  </div>
);

export default ContextualMedia;
